module.exports = __webpack_public_path__ + "img/baerbock-kanzler.5e4ce68f.png";